async function loadFitData(sku) {
  try {
    const response = await fetch(
      `https://kokobay-mizd.vercel.app/api/products/fit/${sku}`
    );

    if (!response.ok) return null;

    return await response.json();
  } catch (err) {
    console.error("Fit API failed", err);
    return null;
  }
}

function renderFitWidget(data) {
  const container = document.getElementById("kokobay-fit-widget");

  if (!container || !data) return;

  // Hide widget if not enough responses
  if (
    typeof data.totalResponses === "number" &&
    data.totalResponses < 3
  ) {
    window.kokobayFitWidgetShown = false;
    container.innerHTML = "";
    return;
  }

  window.kokobayFitWidgetShown = true;

  const small = data.fitBreakdown?.small ?? 0;
  const large = data.fitBreakdown?.large ?? 0;
  const trueFit = data.fitBreakdown?.true ?? 0;

  const total = small + large + trueFit;

  const smallPct = total ? (small / total) * 100 : 0;
  const largePct = total ? (large / total) * 100 : 0;

  const direction = data.direction || "true";

  /*
   * SLIDER
   * 0%   = Runs small
   * 50%  = True to size
   * 100% = Runs large
   *
   * Stronger evidence pushes the dot further
   * towards the relevant edge.
   */
  let sliderLeft = 50;

  if (direction === "small") {
    if (smallPct >= 90) {
      sliderLeft = 5;
    } else if (smallPct >= 80) {
      sliderLeft = 12;
    } else if (smallPct >= 70) {
      sliderLeft = 20;
    } else if (smallPct >= 60) {
      sliderLeft = 30;
    } else {
      sliderLeft = 40;
    }
  }

  if (direction === "large") {
    if (largePct >= 90) {
      sliderLeft = 95;
    } else if (largePct >= 80) {
      sliderLeft = 88;
    } else if (largePct >= 70) {
      sliderLeft = 80;
    } else if (largePct >= 60) {
      sliderLeft = 70;
    } else {
      sliderLeft = 60;
    }
  }

  /*
   * CUSTOMER-FACING COPY
   */
  let summary = "True to size";
  let recommendation = "We recommend choosing your usual size";

  if (direction === "small") {
    if (smallPct >= 90) {
      summary = "Runs very small";
      recommendation = "We strongly recommend choosing one size up";
    } else if (smallPct >= 80) {
      summary = "Runs small";
      recommendation = "We recommend choosing one size up";
    } else if (smallPct >= 70) {
      summary = "Runs small";
      recommendation = "You may prefer one size up";
    } else {
      summary = "Runs slightly small";
      recommendation = "Consider choosing one size up";
    }
  }

  if (direction === "large") {
    if (largePct >= 90) {
      summary = "Runs very large";
      recommendation = "We strongly recommend choosing one size down";
    } else if (largePct >= 80) {
      summary = "Runs large";
      recommendation = "We recommend choosing one size down";
    } else if (largePct >= 70) {
      summary = "Runs large";
      recommendation = "You may prefer one size down";
    } else {
      summary = "Runs slightly large";
      recommendation = "Consider choosing one size down";
    }
  }

  container.innerHTML = `
    <div class="kb-fit-widget">

      <div class="kb-fit-slider">
        <div class="kb-fit-slider-track"></div>

        <div class="kb-fit-tick kb-fit-tick-left"></div>
        <div class="kb-fit-tick kb-fit-tick-center"></div>
        <div class="kb-fit-tick kb-fit-tick-right"></div>

        <div
          class="kb-fit-slider-dot"
          style="left:${sliderLeft}%"
        ></div>
      </div>

      <div class="kb-fit-scale">
        <span class="kb-fit-scale-label">Runs small</span>
        <span class="kb-fit-scale-label">True to size</span>
        <span class="kb-fit-scale-label">Runs large</span>
      </div>

      <div class="kb-fit-result">
        <strong>${summary}</strong>
        <span>Based on ${data.totalResponses} customers</span>
      </div>

      <div class="kb-fit-recommendation">
        ${recommendation}
      </div>

    </div>
  `;
}

async function initFitWidget() {
  const container = document.getElementById("kokobay-fit-widget");

  if (!container) return;

  const sku = container.dataset.sku;

  if (!sku) return;

  const data = await loadFitData(sku);

  renderFitWidget(data);
}

document.addEventListener("DOMContentLoaded", initFitWidget);